import {
  FETCH_INITIAL_TOPO_NODES_SUCCESS,
  CREATE_TOPO_NODE_SUCCESS,
  EDIT_TOPO_NODE_SUCCESS,
  DELETE_TOPO_NODE_SUCCESS,
  UPDATE_DEFAULT_TOPONODE_CONTROL_SUCCESS,
  SET_TOPONODE_DATA_SUCCESS,
  SET_ALL_TOPONODES_SUCCESS
} from './actions';

const initialState = {
  topoNodes: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INITIAL_TOPO_NODES_SUCCESS:
    case EDIT_TOPO_NODE_SUCCESS:
    case CREATE_TOPO_NODE_SUCCESS:
    case SET_TOPONODE_DATA_SUCCESS:
    case DELETE_TOPO_NODE_SUCCESS:
    case UPDATE_DEFAULT_TOPONODE_CONTROL_SUCCESS:
    case SET_ALL_TOPONODES_SUCCESS:
      return {
        ...state,
        topoNodes: action.data
      };
    default:
      return state;
  }
};

export default reducer;
